var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaymentG(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 22,
    viewBox: "0 0 36 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "ig3ds33uea",
    d: "M0.052 0.074L5.426 0.074 5.426 7.875 0.052 7.875z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "6l2a2uo2nc",
    d: "M0.25 0.142L0.398 0.142 0.398 0.488 0.25 0.488z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ealjm2br5e",
    d: "M0.25 0.104L0.406 0.104 0.406 0.481 0.25 0.481z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "qy8soce0og",
    d: "M0.25 0.143L0.406 0.143 0.406 0.394 0.25 0.394z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-28 -89) translate(28 89)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.5,
    height: 21.5,
    x: 0.25,
    y: 0.25,
    fill: "#FFF",
    stroke: "#C7C7C7",
    strokeWidth: 0.5,
    rx: 3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4 6) translate(22.25 3.051)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "e7erumh2hb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ig3ds33uea"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#5F6469",
    d: "M1.017 7.875c.026-.129.097-.239.15-.356.348-.756.697-1.512 1.05-2.266.035-.077.034-.136 0-.213C1.507 3.436.801 1.83.093.226.028.078.028.078.185.078c.27 0 .539.005.808-.003.105-.003.155.027.197.129.496 1.204.997 2.405 1.497 3.608.02.049.043.097.064.147.053-.026.054-.076.07-.115.487-1.203.975-2.405 1.456-3.61.05-.126.111-.165.244-.16.264.012.53.01.794.002.12-.004.133.024.086.132C4.77 1.65 4.14 3.094 3.51 4.538c-.47 1.074-.938 2.149-1.407 3.223-.016.037-.024.076-.036.114h-1.05z",
    mask: "url(#e7erumh2hb)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FCBA13",
    d: "M.625 6.587C.365 6.082.218 5.544.155 4.98c-.003-.036.017-.082-.03-.107v-.027c.03-.064.007-.131.014-.196v-.226c-.007-.065.015-.133-.014-.197V4.2c.064-.134.05-.283.077-.424.084-.443.213-.87.426-1.27.149.04.245.159.36.246.346.26.686.528 1.028.792.045.036.094.068.12.123-.2.582-.186 1.166-.01 1.75-.01.072-.074.099-.122.136-.424.329-.847.659-1.274.984-.03.024-.057.06-.105.049",
    transform: "translate(4 6)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4 6) translate(0 4.301)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "9zyhkjsukd",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#6l2a2uo2nc"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD88C",
    d: "M.295.152v.326C.28.492.264.492.25.476V.154C.264.139.279.138.295.152",
    mask: "url(#9zyhkjsukd)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4 6) translate(0 4.176)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "x8vi2fxaqf",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ealjm2br5e"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFE2AF",
    d: "M.295.478L.25.48V.104c.114.112.03.25.045.374",
    mask: "url(#x8vi2fxaqf)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4 6) translate(0 4.551)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "5zwthyrhvh",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#qy8soce0og"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFE0A7",
    d: "M.25.143l.045.002C.282.228.364.319.25.395V.142z",
    mask: "url(#5zwthyrhvh)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#5F6469",
    d: "M12.156 4.584c0-1.268.002-2.537-.003-3.805 0-.118.03-.15.15-.15.865.006 1.732.001 2.598.004 1.145.003 2.173.813 2.386 1.879.302 1.506-.786 2.543-1.828 2.766-.22.047-.444.06-.668.06-.494 0-.988.004-1.481-.003-.116-.001-.14.036-.14.144.004.969-.001 1.937.005 2.905.001.135-.039.164-.165.158-.233-.01-.467-.01-.7 0-.12.004-.158-.025-.157-.153.006-.959.003-1.918.003-2.877v-.928zM21.132 5.348c.115-1.017-.804-1.548-1.522-1.483-.487.044-.873.25-1.164.638-.051.068-.085.064-.148.023-.237-.154-.475-.306-.718-.45-.08-.048-.08-.081-.027-.15.314-.407.709-.697 1.204-.84.655-.188 1.313-.19 1.96.033.847.29 1.375 1.005 1.387 1.901.016 1.139.005 2.278.01 3.416 0 .085-.026.106-.107.105-.256-.005-.512-.006-.768 0-.089.002-.104-.032-.102-.11.005-.178.003-.358.001-.537 0-.029.018-.07-.017-.085-.045-.019-.059.03-.077.056-.178.242-.387.448-.647.6-.87.505-2.153.24-2.756-.565-.516-.689-.511-1.962.567-2.545.379-.205.786-.3 1.211-.317.608-.024 1.096.017 1.713.31",
    transform: "translate(4 6)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ED362E",
    d: "M2.136 3.668l-1.13-.862c-.127-.098-.252-.2-.378-.3.423-.855 1.064-1.5 1.898-1.955 1.63-.888 3.64-.688 5.05.496.034.03.066.061.102.088.045.035.05.062.005.106-.401.397-.802.796-1.2 1.197-.067.068-.093.003-.127-.026-.322-.278-.69-.467-1.106-.553-1.209-.249-2.429.353-2.968 1.463-.054.113-.098.23-.146.346",
    transform: "translate(4 6)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00AB4D",
    d: "M.625 6.587l1.501-1.169c.19.498.475.926.889 1.27.936.78 2.277.752 3.157.209.023-.014.048-.024.071-.036.056-.006.091.033.13.062.411.312.817.632 1.226.948.04.03.095.056.098.119-.481.459-1.051.76-1.69.924-1.528.39-2.934.14-4.185-.843-.511-.401-.908-.9-1.197-1.484",
    transform: "translate(4 6)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4C7BBD",
    d: "M7.697 7.99L6.243 6.86c.427-.31.733-.706.867-1.224.042-.162.042-.164-.126-.164-.718 0-1.436-.002-2.155.003-.106 0-.149-.02-.147-.138.007-.493.005-.986 0-1.48 0-.103.026-.137.135-.137 1.347.004 2.694.004 4.041 0 .098 0 .13.027.142.123.191 1.529-.093 2.916-1.203 4.06-.03.031-.067.058-.1.087",
    transform: "translate(4 6)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M13.172 2.986c0-.413.003-.825-.002-1.238-.001-.098.014-.14.13-.14.547.008 1.095-.001 1.642.007.75.01 1.356.642 1.35 1.393-.005.742-.62 1.352-1.37 1.356-.539.003-1.078-.001-1.616.003-.102.001-.139-.02-.137-.13.007-.418.003-.835.003-1.251M19.878 5.845c.383.012.792.071 1.158.302.077.049.11.101.103.195-.06.94-1.156 1.694-2.054 1.41-.457-.145-.733-.486-.72-.894.01-.319.179-.546.43-.722.278-.196.635-.295 1.083-.29",
    transform: "translate(4 6)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentG);
export default __webpack_public_path__ + "static/media/payment-g.5b6415604f8d712d41d1a5bf8f9b735a.svg";
export { ForwardRef as ReactComponent };